const pageMyPage = {
    edit: function () {
        const paramList = new FormData();

        // プロフィール変更画面読み込み
        post.postAjaxData("/parent/ajaxProfileEdit", paramList, "", pageMyPage.loadDone, null, null);
    },

    // ロード完了
    loadDone: function (results) {
        $(".js-ajax-content").html(results["template"]);
        modalWindow.enableButton();

        // 都道府県情報の変更のドロップダウン構成
        $("[name=prefectureCode]").unbind();
        $("[name=prefectureCode]").change(function () {
            postCode.changePrefectureDropDownList();
        });

        // 郵便番号検索ボタン
        $(".js-post-code").unbind();
        $(".js-post-code").click(function () {
            const postCodeValue = $("#postCode").val();
            postCode.postCodeToAddress(postCodeValue);
        });

        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            form.post("/parent/ajaxProfileEdit/complete", "#myPage", "更新が完了しました", pageMyPage.editDone);
        });

        pageMyPage.enableEmailChangeButton();
    },

    // 編集まで完了
    editDone: function (results) {
        pageMyPage.profile();
        $(".js-modal-hide").trigger("click");
    },

    // プロフィール情報の取得
    profile: function () {
        const paramList = new FormData();
        post.postAjaxData("/parent/ajaxProfile", paramList, "", pageMyPage.loadProfileDone, null, null);
    },
    // プロフィール読み込み完了
    loadProfileDone: function (results) {
        $(".js-profile-area").html(results["template"]);
        modalWindow.enableButton();

        $("#js-edit-profile").on("click", function () {
            pageMyPage.edit();
        });
    },
    // メールアドレス変更画面読み込み完了
    loadEmailDone: function (results) {
        $(".js-ajax-email-change-content").html(results["template"]);

        modalWindow.enableButton();
        pageMyPage.enableEmailChangeButton();

        // メールアドレス変更を開始するボタンを押す。
        $(".js-email-change-submit").click(function () {
            form.disableButtons(this);

            form.post("/parent/ajaxProfileEdit/email_change/complete", "#emailChange", "", pageMyPage.emailChangeDone);
        });
    },
    // メールアドレス変更の開始。完了。
    emailChangeDone: function (results) {
        $("#js-modal-email-change-input").html(results["template"]);

        modalWindow.enableButton();
        pageMyPage.enableEmailChangeButton();
    },

    // メールアドレス変更ボタンを有効化
    enableEmailChangeButton: function () {
        // メールアドレス変更ボタン
        $(".js-email-change-button").click(function () {
            // メールアドレス変更画面読み込み
            const paramList = new FormData();
            post.postAjaxData(
                "/parent/ajaxProfileEdit/email_change",
                paramList,
                "",
                pageMyPage.loadEmailDone,
                null,
                null
            );

            // プロフィール画面を閉じる
            $("#js-modal-profile").find(".js-modal-hide").trigger("click");
        });
    }
};

window.pageMyPage = pageMyPage;

$(document).ready(function (e) {
    if ($(".js-myPage-page").length === 0) {
        return;
    }

    // 初期実行
    pageMyPage.profile();
});
